// require right lang based on html lang code
let lang = 'en';

switch ($('html').attr('lang')) {
    case 'cs':
    case 'cs-CZ':
        lang = 'cs';
        break;
    case 'de':
    case 'de-AT':
    case 'de-DE':
        lang = 'de';
        break;
    case 'hr':
    case 'hr-HR':
        lang = 'hr';
        break;
    case 'hu':
    case 'hu-HU':
        lang = 'hu';
        break;
    case 'sk':
    case 'sk-SK':
        lang = 'sk';
        break;
    case 'pl':
    case 'pl-PL':
        lang = 'pl';
        break;
}

require(['parsleyjs/dist/parsley', 'parsleyjs/dist/i18n/' + lang], () => {
    let $forms = $('form').not('[novalidate]:not(.wpcf7-form)');

    // add parsley only to those forms, that should be validated
    $forms.parsley({
        trigger: 'focusout',
        errorClass: 'has-error',
        successClass: 'is-valid',
        errorsWrapper: '<ul class="form-errors"></ul>',
        classHandler: el => {
            // remove possible existing errors
            el.$element.closest('.input-group').find('.form-errors').remove();
            el.$element.closest('.label-floating').find('.form-errors').remove();

            let $inputGroup = el.$element.closest('.input-group'),
                $labelFloating = el.$element.closest('.label-floating');

            if ($inputGroup.length) {
                return $inputGroup;
            }

            if ($labelFloating.length) {
                return $labelFloating;
            }

            return el.$element;
        },
        errorsContainer: el => {
            // remove possible existing errors
            el.$element.closest('.input-group').find('.form-errors').remove();
            el.$element.closest('.label-floating').find('.form-errors').remove();

            // return label-floating__label or input-group
            let $labelFloating = el.$element.closest('.label-floating');

            if ($labelFloating.length) {
                return $labelFloating.find('.label-floating__label');
            }

            return el.$element.closest('.input-group');
        },
    });

    // remove our loading indicator if we had an error
    $forms.each(function (i, form) {
        const $form = $(form);

        $form.parsley().on('form:error', function () {
            $form.find('.is-loading').removeClass('is-loading');
        });
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/lib/form/validation.js